import { createBrowserRouter } from "react-router-dom";

import { App } from "./App";
import { REACT_APP_BASE_URL } from "./config";

const router = createBrowserRouter([{ path: "*", element: <App /> }], { basename: REACT_APP_BASE_URL });

export { router };
